// extracted by mini-css-extract-plugin
export var heroImage = "_ga-1";
export var modal = "_ga-0";